/**
 * These values are set when creating a new Surfboard Order as source in the metadata payload
 * The webhooks order related messages published by the Surfboard payment gateway will contain this metadata information
 * Used for identifying at Surfboard webhooks
 */
export enum SURFBOARD_WEBHOOKS_APPLICATION_SOURCE_TYPE {
  WEB_GIFTCARD = 'webgiftcard',
  NOPOS_ORDER = 'noposorder',
  NOPOS_GIFTCARD = 'noposgiftcard',
}